module.exports = __webpack_public_path__ + "img/golden-card.2a1634d8.png";